import React from 'react'
import { Timeline } from 'antd';
import { HashLink as Link } from 'react-router-hash-link';
/**
 * Отображение временной линии появления ЕМД () на основе номера версии 
 */
class EMDHistoryTimeline extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.onSelectedInList = this.onSelectedInList.bind(this);
  }

  onSelectedInList(e, IRI) {
    e.preventDefault();
    const { onSelected } = this.props
    if (onSelected) onSelected(IRI)
  }

  render() {
    const { assets, selected } = this.props;
    console.log(this);
    return (
      <Timeline>
        {assets.map((item, i) =>
          (selected == item.IRI ?
            <Timeline.Item color="green" key={i}><b>{item.name}</b> <p><i>{item.description}</i></p></Timeline.Item>
            :
            <Timeline.Item key={i} onClick={(e) => this.onSelectedInList(e, item.IRI)}>
              <Link to= {"#"+item.IRI}>{item.name}</Link> <p><i>{item.description}</i></p>
            </Timeline.Item>
          )
        )}
      </Timeline>
    );
  }
}

export default EMDHistoryTimeline;